import {
  Flex,
  Typography,
  Space,
  Button,
  ConfigProvider,
  Slider,
  Popover,
} from "antd";
import { AUDIO_VIDEO_CONTROLS_HEIGHT } from "../../constants";
import { formatSecondsAsMMSS } from "helpers/utils";
import { PauseIcon, PlayIcon, WarningIcon } from "@phosphor-icons/react";
import { useAntTheme } from "hooks/useAntTheme";

export const TemplatePlayer = ({
  previewWidth,
  currentTime,
  duration,
  isPlaying,
  onSliderChange,
  onPlayPauseClick,
  warningMessage,
}: {
  previewWidth: number;
  currentTime: number;
  duration: number;
  isPlaying: boolean;
  onSliderChange: (value: number) => void;
  onPlayPauseClick: () => Promise<void>;
  warningMessage?: string;
}) => {
  const { theme } = useAntTheme();

  return (
    <Flex
      data-interactive
      justify="center"
      align="center"
      vertical
      style={{
        width: previewWidth,
        minHeight: `${AUDIO_VIDEO_CONTROLS_HEIGHT}px`,
      }}
    >
      <Flex
        align="center"
        style={{ width: "100%", color: "#000", position: "relative" }}
        gap={5}
      >
        <Space>
          <Typography.Text style={{ fontSize: 11, whiteSpace: "nowrap" }}>
            {formatSecondsAsMMSS(currentTime)}
            <Typography.Text type="secondary" style={{ fontSize: 11 }}>
              / {formatSecondsAsMMSS(duration)}
            </Typography.Text>
          </Typography.Text>
          <Button
            type="text"
            shape="circle"
            onClick={() => {
              onPlayPauseClick().catch((error) =>
                console.error("Error playing/pausing", error)
              );
            }}
            icon={
              isPlaying ? (
                <PauseIcon
                  size={24}
                  weight="fill"
                  style={{ verticalAlign: "text-top" }}
                />
              ) : (
                <PlayIcon
                  size={24}
                  weight="fill"
                  style={{ verticalAlign: "text-top" }}
                />
              )
            }
          />
        </Space>
        <ConfigProvider
          theme={{
            components: {
              Slider: {
                railBg: theme.colorBorder,
              },
            },
          }}
        >
          <div style={{ width: "90%" }}>
            <Slider
              value={currentTime}
              onChange={onSliderChange}
              max={duration}
              tooltip={{ open: false }}
              step={0.01}
              styles={{
                tracks: {
                  background: "#fff",
                },
              }}
            />
          </div>
        </ConfigProvider>
        {warningMessage && (
          <Popover content={warningMessage} placement="top" arrow={false}>
            <WarningIcon size={24} weight="fill" color={theme.colorWarning} />
          </Popover>
        )}
      </Flex>
    </Flex>
  );
};
